import React, { Fragment } from 'react'
import { viewportContainer, modalContainer } from '../../core'
import Layout from '../../components/Layout'
import Section from '../../sections'
import BannerSection from '../../sections/BannerSection'

import './page.scss'

class Page extends React.Component {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      modalContainer.handleHashChange()
    }

    this.handleResize()
    viewportContainer.onResize(this.handleResize)
    viewportContainer.onScroll(this.handleScroll)

    setTimeout(this.handleResize, 200)
  }

  componentWillUnmount() {
    viewportContainer.offResize(this.handleResize)
    viewportContainer.offScroll(this.handleScroll)
    modalContainer.reset()
  }

  handleMouseWheel = (e) => {
    if (window._IS_AUTO_SCROLLING) return 

    if (this.isTicking) return
    this.isTicking = true

    requestAnimationFrame(() => {

      const delta = Math.max(-40, Math.min(e.deltaY, 30))
      const newY = this.getY(this.lastY + delta)
  
      window.scrollTo(0,newY)
      this.lastY = newY

      this.isTicking = false
    })
  }

  getY = (y) => {
    const fullScroll = document.body.clientHeight - viewportContainer.vh + this.headerHeight
    return Math.min(fullScroll, Math.max(0, y))
  }

  getSectionRefs = () => {
    const data = this.props.data || {}
    return (data.contentModules || []).map(() => (
      React.createRef()
    ))
  }

  desktopSectionRefs = this.getSectionRefs()
  mobileSectionRefs = this.getSectionRefs()

  handleResize = () => {
    this.headerHeight = document.getElementsByTagName('HEADER')[0].clientHeight

    const sectionRefs = viewportContainer.vw < 768
      ? this.mobileSectionRefs
      : this.desktopSectionRefs

    this.sectionTargets = sectionRefs
      .filter(s => !!s.current)
      .map(s => {
        const rect = s.current.getBoundingClientRect()

        const top = viewportContainer.vw < 768 
          ? rect.top + rect.height + window.pageYOffset - viewportContainer.vh
          : rect.top + window.pageYOffset

        return {
          top,
          triggerDown: Math.max(50, top - 300),
          forceDuration: 300,
        }
      })

    const lastSectionRef = this.mobileSectionRefs.filter(s => !!s.current).reverse()[0]

    if (lastSectionRef) {
      const rect = lastSectionRef.current.getBoundingClientRect()
      const top = rect.top + window.pageYOffset + 1

      this.sectionTargets.push({
        top,
        triggerDown: Math.max(50, top - 300),
      })
    }
  }

  handleScroll = (e) => {
    // if (viewportContainer.vw < 768 || window._IS_AUTO_SCROLLING) {
    //   return
    // }
    // clearTimeout(this.scrollTimeout)
    // this.isScrolling = true
    // this.scrollTimeout = setTimeout(() => {
    //   this.isScrolling = false
    // }, 200)

    // const { y, scrollDir, scrollSpeed } = viewportContainer

    // if (scrollDir === 1) {
    //   this.sectionTargets.find(target => {
    //     if (target.top < 100) return false

    //     const isTriggered = (
    //       y >= target.triggerDown
    //       || scrollSpeed > 40
    //     )

    //     if (isTriggered && y < target.top) {
    //       window._IS_AUTO_SCROLLING = true
    //       // document.body.style.overflow = 'hidden'
    //       scrollTo(window, { 
    //         top: target.top + 1,
    //         duration: target.forceDuration || 500,
    //         easing: 'ease-out',
    //       }).then(() => {
    //         this.lastY = this.getY(viewportContainer.y)

    //         setTimeout(() => {
    //           const int = setInterval(() => {
    //             if (!this.isScrolling) {
    //               window._IS_AUTO_SCROLLING = false
    //               // document.body.style.overflow = 'auto'
    //               clearInterval(int)
    //             }
    //           }, 100)
    //         }, 500)
            
    //         // window has scrolled 500 pixels down the page
    //       });
    //       return true
    //     }
    //   })
    // }
  }

  render() {
    const data = this.props.data || {}
    const { html, pageTitle, component } = data

    return (
      <Layout title={pageTitle}>
        <div styleName="page">
          {data.banner && <BannerSection data={data.banner} isFixed />}
          <section styleName="content">
            {data.banner && <div styleName="hidden">
              <BannerSection data={data.banner} />
            </div>}
            {data.contentModules && data.contentModules.map((module, i) => (
              <Fragment key={module.id}>
                <div styleName='section-target' ref={this.desktopSectionRefs[i]} />
                <Section 
                  typename={module.__typename} 
                  context={data}
                  id={module.id} 
                />
                <div styleName='section-target' ref={this.mobileSectionRefs[i]} />
              </Fragment>
            ))}
            {html && <div styleName="html"><div styleName="inner" dangerouslySetInnerHTML={{ __html: html }}/></div> }
            {component && <div styleName="html">{component}</div> }
          </section>
        </div>
      </Layout>
    )
  }
}

export default Page